import {
  WSEmptyState,
  WSEmptyStateProps
} from "@wingspanhq/fe-component-library";
import React from "react";

type Props = Pick<WSEmptyStateProps, "orientation" | "size">;

export const EmptyStateAwaitingContractor: React.FC<Props> = ({
  orientation = "horizontal",
  size = "S"
}) => (
  <WSEmptyState
    type="tasks"
    orientation={orientation}
    size={size}
    title="Contractor changes in progress"
    description="Waiting for the contractor to make changes and resubmit"
    hasBorder
    bgColor="white"
  />
);
